"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DatePickerCenter = void 0;
var _CenterStack = _interopRequireDefault(require("../../../CenterStack/index.js"));
var _react = _interopRequireWildcard(require("react"));
var _StyledMonthSelector = require("./StyledMonthSelector.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DatePickerCenter = props => {
  const {
    mode,
    selectedDate,
    selectedDates,
    day,
    onDateChange,
    onChangeDatesHande,
    sDate,
    eDate,
    setStartDate,
    selDate,
    setEndDate,
    onChangeStartEndDateHandle,
    setSelectedDate,
    isSelected,
    isToday,
    isEnabled,
    isRange,
    daysColor,
    disabledDaysColor,
    borderRadius,
    calenderBoxShadow,
    calenderBorderWidth,
    calenderBorderStyle,
    calenderBorderColor,
    dateWeekHeight,
    dateWeekWidth,
    dateWeekMargin,
    dateBgColor,
    hoverDateBgColor,
    dateBorderRadius,
    dateBorderWidth,
    dateBorderStyle,
    dateBorderColor,
    dateBoxShadow,
    dateFontFamily,
    dateFontStyle,
    dateFontWeight,
    dateFontSize,
    dateTransformation,
    dateDecoration,
    hoverDateTextColor,
    dateLineHeight,
    disabledDateBgColor,
    disabledDateBorderRadius,
    disabledDateBorderWidth,
    disabledDateBorderStyle,
    disabledDateBorderColor,
    disabledDateBoxShadow,
    disabledDateFontFamily,
    disabledDateFontStyle,
    disabledDateFontWeight,
    disabledDateFontSize,
    disabledDateTransformation,
    disabledDateDecoration
  } = props;
  const [selDates, setSelectedDates] = (0, _react.useState)(selectedDates);
  const onClickCenterStack = () => {
    if (!isEnabled) return;
    switch (mode) {
      case 'date':
        if (selDate === undefined) {
          setSelectedDate(day);
          onDateChange?.(day);
        } else if (selDate.getTime() === day.getTime()) {
          setSelectedDate(undefined);
          onDateChange?.(undefined);
        } else {
          setSelectedDate(day);
          onDateChange?.(day);
        }
        break;
      case 'dates':
        if (selDates) {
          let newArr = [];
          let isContains = false;
          for (let el of selDates) {
            if (el?.getTime() != day?.getTime()) {
              newArr.push(el);
            } else {
              isContains = true;
            }
          }
          !isContains && newArr.push(day);
          setSelectedDates(newArr);
          onChangeDatesHande?.(newArr);
        } else {
          setSelectedDates([day]);
          onChangeDatesHande?.([day]);
        }
        break;
      case 'range':
        if (sDate === undefined && eDate === undefined) {
          setStartDate && setStartDate(day);
          onChangeStartEndDateHandle?.(day, undefined);
        } else if (sDate && sDate.getTime() == day.getTime()) {
          setStartDate && setStartDate(undefined);
          if (eDate) {
            setStartDate && setStartDate(eDate);
            setEndDate && setEndDate(undefined);
            onChangeStartEndDateHandle?.(eDate, undefined);
          } else {
            onChangeStartEndDateHandle?.(undefined, undefined);
          }
        } else if (eDate?.getTime() == day.getTime()) {
          setEndDate && setEndDate(undefined);
          onChangeStartEndDateHandle?.(sDate, undefined);
        } else if (sDate && eDate === undefined) {
          if (day.getTime() > sDate.getTime()) {
            setEndDate && setEndDate(day);
            onChangeStartEndDateHandle?.(sDate, day);
          } else {
            setEndDate && setEndDate(sDate);
            setStartDate && setStartDate(day);
            onChangeStartEndDateHandle?.(day, sDate);
          }
        } else {
          if (sDate && day?.getTime() < sDate?.getTime()) {
            setStartDate && setStartDate(day);
            onChangeStartEndDateHandle?.(day, eDate);
          } else if (eDate && day?.getTime() > eDate.getTime()) {
            setEndDate && setEndDate(day);
            onChangeStartEndDateHandle?.(sDate, day);
          } else {
            setStartDate && setStartDate(undefined);
            setEndDate && setEndDate(undefined);
            onChangeStartEndDateHandle?.(undefined, undefined);
          }
        }
        break;
    }
  };
  const typographyColor = isEnabled ? daysColor : disabledDaysColor;
  const isTodayStyle = isToday ? ' datepicker__day-btn-today' : '';
  const isSelectedStyle = isSelected ? ' datepicker__day-selected' : '';
  const isRangeStyle = isRange ? ' datepicker__day-ranged' : '';
  const className = isEnabled ? `datepicker__day-btn ${isTodayStyle} ${isSelectedStyle} ${isRangeStyle}` : '';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CenterStack.default, {
    onClick: onClickCenterStack,
    className: className,
    width: dateWeekWidth,
    height: dateWeekHeight,
    margin: dateWeekMargin,
    bg: isEnabled ? dateBgColor : disabledDateBgColor,
    hoverBg: hoverDateBgColor,
    borderRadius: `${isEnabled ? dateBorderRadius : disabledDateBorderRadius}px`,
    borderWidth: isEnabled ? dateBorderWidth : disabledDateBorderWidth,
    borderStyle: isEnabled ? dateBorderStyle : disabledDateBorderStyle,
    borderColor: isEnabled ? dateBorderColor : disabledDateBorderColor,
    boxShadow: isEnabled ? dateBoxShadow : disabledDateBoxShadow,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledMonthSelector.StyledDateTypography, {
      variant: "button-medium",
      color: typographyColor,
      fontFamily: isEnabled ? dateFontFamily : disabledDateFontFamily,
      fontStyle: isEnabled ? dateFontStyle : disabledDateFontStyle,
      fontWeight: `${isEnabled ? dateFontWeight : disabledDateFontWeight}`,
      fontSize: `${isEnabled ? dateFontSize : disabledDateFontSize}px`,
      textTransformation: isEnabled ? dateTransformation : disabledDateTransformation,
      textDecoration: isEnabled ? dateDecoration : disabledDateDecoration,
      hoverTextColor: hoverDateTextColor,
      lineHeight: `${dateLineHeight}px`,
      children: day.getDate()
    })
  });
};
exports.DatePickerCenter = DatePickerCenter;
var _default = exports.default = DatePickerCenter;